import { useGSAP } from '@gsap/react';
import { useRef, useState } from 'react';
import gsap from 'gsap';

export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQListProps {
  items: FAQItem[];
}

const FAQList = ({ items }: FAQListProps) => {
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);


  const containerRef = useRef(null)
  
  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {
    if (!containerRef.current) return;

      const itemsEls = gsap.utils.toArray<HTMLElement>(".faq-item");

      gsap.from(itemsEls, {
        opacity: 0,
        y: '2rem',
        duration: 0.9,
        stagger: 0.15,
        ease: "power1.out",
        scrollTrigger: {
          trigger: containerRef.current,
          // markers: true,
          start: "top 80%",
          end: "bottom 20%",
        },
      });

    })

  });

  return (
    <div className='container-grid '>


      <div ref={containerRef} className='w-full md:col-span-5 lg:col-span-8 lg:col-start-3'>
        {items?.map((item, index) => (
          <div
            key={index}
            onClick={() => setCurrentIndex(currentIndex === index ? null : index)}
            className={`faq-item cursor-pointer r py-[1.8rem] md:py-[2.rem] lg:py-[2.4rem] xl:py-[3.2rem] border-b-[1px] ${
              index === currentIndex ? 'border-dusty-blue' : 'border-dusty-blue-10'
            } w-full`}
          >
            <div className="flex text-left justify-between items-start">
              <p className="heading-4 opacity-20 mr-[1.6rem] md:mr-[3.2rem] lg:mr-[8rem]">0{index + 1}</p>
              <div className='w-full'>
                <h3 className='heading-4'>{item.question}</h3>
                <div
                  className={`${
                    index === currentIndex ? ' grid-rows-[1fr]' : 'grid-rows-[0fr]'
                  } text-left grid  duration-500 ease-out transition-[grid-template-rows] w-full`}
                >
                  <div className='w-full  overflow-hidden'>
                    <div
                      onClick={(e) => e.stopPropagation()}
                      className="[&>a]:duration-300     [&_ul]:flex
                      [&_ul]:flex-col
                      [&_li]:relative
                      [&_li]:pl-[1.5rem]

                      [&_li::before]:content-['']
                      [&_li::before]:absolute
                      [&_li::before]:left-0
                      [&_li::before]:top-[0.7rem]
                      [&_li::before]:w-[0.5rem]
                      [&_li::before]:h-[0.5rem]
                      [&_li::before]:bg-dark-blue
                       cursor-default [&>a]:underline [&>a]:transition-opacity [&>a]:hover:opacity-80 pt-[0.8rem] md:pt-[1.2rem] lg:pt-[2rem] text-1"
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                  </div>

                </div>
              </div>

              <div className="p-[1rem] ml-[1.6rem]  md:ml-[3.2rem] lg:ml-[8rem]">
                <img
                  className={`${
                    index === currentIndex ? '-rotate-90' : 'rotate-90'
                  } min-w-[1.2rem] transition-transform duration-500 min-h-[1.2rem]`}
                  src="/images/arrow_right.svg"
                  fetchPriority="low"
                  loading='lazy'
                  alt="Стрелка вправо"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQList;